package com.dotpx.ambient

internal class ScenePreset(
    val texture: TextureKind,
    val bedLevel: Float,
    val brightness: Float,
    val motionRate: Double,
    val droneFrequency: Double,
    val droneLevel: Float,
    val toneFrequency: Double,
    val toneLevel: Float,
    val tonePulseRate: Double,
    val event: EventKind,
    val eventLevel: Float,
    val eventDelayLow: Double,
    val eventDelayHigh: Double,
    val secondaryEvent: EventKind,
    val secondaryLevel: Float,
    val secondaryDelayLow: Double,
    val secondaryDelayHigh: Double,
)

internal val SCENE_PRESETS = arrayOf(
    ScenePreset(TextureKind.Rain, 0.145f, 0.80f, 0.075, 55.0, 0.010f, 0.0, 0f, 0.0, EventKind.Drip, 0.044f, 2.6, 8.5, EventKind.Metal, 0.030f, 13.0, 31.0),
    ScenePreset(TextureKind.Train, 0.120f, 0.34f, 1.28, 72.0, 0.020f, 0.0, 0f, 0.0, EventKind.TrainJoint, 0.055f, 0.48, 0.92, EventKind.Creak, 0.027f, 12.0, 34.0),
    ScenePreset(TextureKind.Surf, 0.170f, 0.54f, 0.105, 43.0, 0.006f, 5_080.0, 0.003f, 9.2, EventKind.WaveSlap, 0.065f, 2.1, 5.8, EventKind.Bell, 0.033f, 17.0, 43.0),
    ScenePreset(TextureKind.Room, 0.105f, 0.38f, 0.68, 50.0, 0.029f, 147.0, 0.015f, 0.76, EventKind.Metal, 0.042f, 5.0, 16.0, EventKind.Relay, 0.050f, 13.0, 35.0),
    ScenePreset(TextureKind.Water, 0.110f, 0.20f, 0.092, 41.0, 0.018f, 0.0, 0f, 0.0, EventKind.Drip, 0.055f, 2.2, 7.5, EventKind.Rock, 0.043f, 25.0, 67.0),
    ScenePreset(TextureKind.Steam, 0.130f, 0.56f, 0.35, 37.0, 0.025f, 59.0, 0.008f, 0.24, EventKind.Thunder, 0.065f, 25.0, 74.0, EventKind.Beep, 0.025f, 36.0, 82.0),
    ScenePreset(TextureKind.Wind, 0.140f, 0.48f, 0.067, 118.0, 0.015f, 337.0, 0.010f, 0.09, EventKind.Metal, 0.040f, 6.0, 19.0, EventKind.Creak, 0.032f, 20.0, 55.0),
    ScenePreset(TextureKind.Forest, 0.085f, 0.48f, 0.032, 71.0, 0.004f, 0.0, 0f, 0.0, EventKind.Higurashi, 0.034f, 0.5, 2.2, EventKind.Higurashi, 0.027f, 1.5, 4.2),
    ScenePreset(TextureKind.Rain, 0.078f, 0.56f, 0.17, 52.0, 0.004f, 0.0, 0f, 0.0, EventKind.LeafDrip, 0.037f, 12.0, 36.0, EventKind.Drip, 0.025f, 2.3, 7.5),
    ScenePreset(TextureKind.Surf, 0.125f, 0.64f, 0.09, 58.0, 0.006f, 5_300.0, 0.004f, 8.8, EventKind.Bird, 0.045f, 7.0, 14.0, EventKind.Rock, 0.038f, 22.0, 55.0),
    ScenePreset(TextureKind.Room, 0.048f, 0.16f, 0.018, 64.0, 0.005f, 0.0, 0f, 0.0, EventKind.Creak, 0.023f, 17.0, 52.0, EventKind.Metal, 0.020f, 10.0, 31.0),
    ScenePreset(TextureKind.Fire, 0.115f, 0.42f, 0.055, 63.0, 0.008f, 135.0, 0.006f, 0.12, EventKind.Drip, 0.032f, 2.6, 8.0, EventKind.Spark, 0.038f, 0.9, 4.0),
    ScenePreset(TextureKind.Water, 0.135f, 0.54f, 0.18, 76.0, 0.004f, 5_120.0, 0.006f, 10.1, EventKind.Frog, 0.032f, 7.0, 23.0, EventKind.WaveSlap, 0.038f, 3.0, 10.0),
    ScenePreset(TextureKind.Forest, 0.125f, 0.62f, 0.071, 46.0, 0.006f, 0.0, 0f, 0.0, EventKind.Higurashi, 0.031f, 0.8, 3.0, EventKind.Thunder, 0.068f, 27.0, 69.0),
    ScenePreset(TextureKind.Surf, 0.115f, 0.22f, 0.13, 34.0, 0.022f, 71.0, 0.008f, 0.07, EventKind.Creak, 0.048f, 13.0, 38.0, EventKind.Metal, 0.038f, 20.0, 57.0),
    ScenePreset(TextureKind.Wind, 0.100f, 0.33f, 0.030, 83.0, 0.006f, 0.0, 0f, 0.0, EventKind.Bird, 0.055f, 6.2, 11.4, EventKind.Drip, 0.018f, 6.0, 14.0),
    ScenePreset(TextureKind.Wind, 0.085f, 0.24f, 0.018, 52.0, 0.013f, 5_480.0, 0.002f, 9.9, EventKind.InsectCall, 0.034f, 13.5, 21.0, EventKind.Drip, 0.024f, 7.0, 17.0),
    ScenePreset(TextureKind.Fire, 0.130f, 0.33f, 0.16, 44.0, 0.015f, 520.0, 0.006f, 0.11, EventKind.Metal, 0.045f, 8.0, 24.0, EventKind.Relay, 0.035f, 11.0, 32.0),
    ScenePreset(TextureKind.Room, 0.070f, 0.38f, 0.026, 59.0, 0.006f, 0.0, 0f, 0.0, EventKind.Dove, 0.047f, 8.4, 25.5, EventKind.TrainJoint, 0.022f, 8.0, 22.0),
    ScenePreset(TextureKind.Forest, 0.115f, 0.52f, 0.052, 126.0, 0.004f, 0.0, 0f, 0.0, EventKind.Drip, 0.026f, 4.0, 13.0, EventKind.Creak, 0.032f, 14.0, 36.0),
    ScenePreset(TextureKind.Steam, 0.115f, 0.60f, 0.22, 52.0, 0.016f, 570.0, 0.004f, 0.11, EventKind.Radio, 0.042f, 16.0, 48.0, EventKind.Metal, 0.032f, 8.0, 25.0),
    ScenePreset(TextureKind.Surf, 0.180f, 0.38f, 0.16, 38.0, 0.016f, 85.0, 0.006f, 0.07, EventKind.Thunder, 0.072f, 25.0, 64.0, EventKind.WaveSlap, 0.060f, 2.0, 6.2),
    ScenePreset(TextureKind.Fire, 0.125f, 0.40f, 0.047, 74.0, 0.008f, 690.0, 0.005f, 0.08, EventKind.Spark, 0.042f, 0.7, 3.5, EventKind.Creak, 0.035f, 8.0, 24.0),
    ScenePreset(TextureKind.Rain, 0.105f, 0.66f, 0.31, 60.0, 0.009f, 120.0, 0.006f, 0.14, EventKind.Drip, 0.038f, 1.8, 6.5, EventKind.Metal, 0.026f, 16.0, 41.0),
    ScenePreset(TextureKind.Fire, 0.110f, 0.30f, 0.060, 48.0, 0.007f, 190.0, 0.004f, 0.07, EventKind.Frog, 0.032f, 8.0, 24.0, EventKind.WaveSlap, 0.030f, 4.0, 12.0),
    // MountainBrook
    ScenePreset(
        texture = TextureKind.Brook, bedLevel = 0.130f, brightness = 0.40f, motionRate = 0.17,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Bubble, eventLevel = 0.030f, eventDelayLow = 1.20, eventDelayHigh = 4.00,
        secondaryEvent = EventKind.Bird, secondaryLevel = 0.030f, secondaryDelayLow = 8.00, secondaryDelayHigh = 20.00,
    ),
    // BambooPath
    ScenePreset(
        texture = TextureKind.Forest, bedLevel = 0.120f, brightness = 0.50f, motionRate = 0.09,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Creak, eventLevel = 0.035f, eventDelayLow = 3.00, eventDelayHigh = 9.00,
        secondaryEvent = EventKind.Bird, secondaryLevel = 0.025f, secondaryDelayLow = 12.00, secondaryDelayHigh = 28.00,
    ),
    // SnowboundHut
    ScenePreset(
        texture = TextureKind.Blizzard, bedLevel = 0.130f, brightness = 0.30f, motionRate = 0.07,
        droneFrequency = 48.0, droneLevel = 0.006f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.FootstepSnow, eventLevel = 0.036f, eventDelayLow = 5.00, eventDelayHigh = 12.00,
        secondaryEvent = EventKind.Creak, secondaryLevel = 0.025f, secondaryDelayLow = 16.00, secondaryDelayHigh = 38.00,
    ),
    // TinRoofRain
    ScenePreset(
        texture = TextureKind.Rain, bedLevel = 0.120f, brightness = 0.60f, motionRate = 0.13,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Drip, eventLevel = 0.026f, eventDelayLow = 2.00, eventDelayHigh = 8.00,
        secondaryEvent = EventKind.Thunder, secondaryLevel = 0.055f, secondaryDelayLow = 30.00, secondaryDelayHigh = 70.00,
    ),
    // WaterfallPool
    ScenePreset(
        texture = TextureKind.Waterfall, bedLevel = 0.140f, brightness = 0.40f, motionRate = 0.05,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Bubble, eventLevel = 0.034f, eventDelayLow = 1.00, eventDelayHigh = 5.00,
        secondaryEvent = EventKind.Rock, secondaryLevel = 0.026f, secondaryDelayLow = 16.00, secondaryDelayHigh = 42.00,
    ),
    // LateNightOffice
    ScenePreset(
        texture = TextureKind.BrownNoise, bedLevel = 0.095f, brightness = 0.25f, motionRate = 0.05,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.ClockTick, eventLevel = 0.022f, eventDelayLow = 0.80, eventDelayHigh = 1.20,
        secondaryEvent = EventKind.Relay, secondaryLevel = 0.026f, secondaryDelayLow = 18.00, secondaryDelayHigh = 45.00,
    ),
    // DistantHighway
    ScenePreset(
        texture = TextureKind.DistantTraffic, bedLevel = 0.120f, brightness = 0.35f, motionRate = 0.04,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Metal, eventLevel = 0.020f, eventDelayLow = 20.00, eventDelayHigh = 45.00,
        secondaryEvent = EventKind.Bird, secondaryLevel = 0.024f, secondaryDelayLow = 15.00, secondaryDelayHigh = 35.00,
    ),
    // HarborEngine
    ScenePreset(
        texture = TextureKind.BoatEngine, bedLevel = 0.100f, brightness = 0.25f, motionRate = 0.13,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.BuoyBell, eventLevel = 0.031f, eventDelayLow = 18.00, eventDelayHigh = 42.00,
        secondaryEvent = EventKind.WaveSlap, secondaryLevel = 0.035f, secondaryDelayLow = 3.00, secondaryDelayHigh = 9.00,
    ),
    // SummerVeranda
    ScenePreset(
        texture = TextureKind.Forest, bedLevel = 0.090f, brightness = 0.40f, motionRate = 0.04,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.WindChime, eventLevel = 0.032f, eventDelayLow = 8.00, eventDelayHigh = 22.00,
        secondaryEvent = EventKind.Cricket, secondaryLevel = 0.027f, secondaryDelayLow = 2.00, secondaryDelayHigh = 6.00,
    ),
    // MoonlitStream
    ScenePreset(
        texture = TextureKind.Brook, bedLevel = 0.110f, brightness = 0.30f, motionRate = 0.09,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Owl, eventLevel = 0.030f, eventDelayLow = 14.00, eventDelayHigh = 35.00,
        secondaryEvent = EventKind.Bubble, secondaryLevel = 0.026f, secondaryDelayLow = 2.00, secondaryDelayHigh = 7.00,
    ),
    // SnowForestWalk
    ScenePreset(
        texture = TextureKind.Wind, bedLevel = 0.090f, brightness = 0.20f, motionRate = 0.025,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.FootstepSnow, eventLevel = 0.040f, eventDelayLow = 2.00, eventDelayHigh = 5.00,
        secondaryEvent = EventKind.BranchSnap, secondaryLevel = 0.028f, secondaryDelayLow = 15.00, secondaryDelayHigh = 35.00,
    ),
    // GreenhouseRain
    ScenePreset(
        texture = TextureKind.Rain, bedLevel = 0.100f, brightness = 0.50f, motionRate = 0.11,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Bubble, eventLevel = 0.023f, eventDelayLow = 7.00, eventDelayHigh = 18.00,
        secondaryEvent = EventKind.Drip, secondaryLevel = 0.028f, secondaryDelayLow = 1.00, secondaryDelayHigh = 5.00,
    ),
    // BehindWaterfall
    ScenePreset(
        texture = TextureKind.Waterfall, bedLevel = 0.120f, brightness = 0.20f, motionRate = 0.035,
        droneFrequency = 35.0, droneLevel = 0.006f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Drip, eventLevel = 0.032f, eventDelayLow = 2.00, eventDelayHigh = 7.00,
        secondaryEvent = EventKind.Rock, secondaryLevel = 0.034f, secondaryDelayLow = 12.00, secondaryDelayHigh = 30.00,
    ),
    // SleepingFerry
    ScenePreset(
        texture = TextureKind.BoatEngine, bedLevel = 0.090f, brightness = 0.20f, motionRate = 0.08,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Creak, eventLevel = 0.026f, eventDelayLow = 12.00, eventDelayHigh = 30.00,
        secondaryEvent = EventKind.BuoyBell, secondaryLevel = 0.024f, secondaryDelayLow = 22.00, secondaryDelayHigh = 55.00,
    ),
    // AutumnFootpath
    ScenePreset(
        texture = TextureKind.Forest, bedLevel = 0.100f, brightness = 0.50f, motionRate = 0.065,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.FootstepGravel, eventLevel = 0.034f, eventDelayLow = 2.00, eventDelayHigh = 5.00,
        secondaryEvent = EventKind.BranchSnap, secondaryLevel = 0.030f, secondaryDelayLow = 10.00, secondaryDelayHigh = 24.00,
    ),
    // QuietServerRoom
    ScenePreset(
        texture = TextureKind.Ventilation, bedLevel = 0.090f, brightness = 0.25f, motionRate = 0.06,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Relay, eventLevel = 0.022f, eventDelayLow = 12.00, eventDelayHigh = 32.00,
        secondaryEvent = EventKind.Beep, secondaryLevel = 0.018f, secondaryDelayLow = 25.00, secondaryDelayHigh = 60.00,
    ),
    // DawnOverpass
    ScenePreset(
        texture = TextureKind.DistantTraffic, bedLevel = 0.100f, brightness = 0.30f, motionRate = 0.055,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.FootstepGravel, eventLevel = 0.030f, eventDelayLow = 5.00, eventDelayHigh = 14.00,
        secondaryEvent = EventKind.BicyclePass, secondaryLevel = 0.035f, secondaryDelayLow = 18.00, secondaryDelayHigh = 40.00,
    ),
    // BambooWaterGarden
    ScenePreset(
        texture = TextureKind.Brook, bedLevel = 0.095f, brightness = 0.35f, motionRate = 0.1,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Creak, eventLevel = 0.030f, eventDelayLow = 8.00, eventDelayHigh = 20.00,
        secondaryEvent = EventKind.WindChime, secondaryLevel = 0.025f, secondaryDelayLow = 14.00, secondaryDelayHigh = 34.00,
    ),
    // BlizzardStation
    ScenePreset(
        texture = TextureKind.Blizzard, bedLevel = 0.120f, brightness = 0.40f, motionRate = 0.09,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Metal, eventLevel = 0.026f, eventDelayLow = 14.00, eventDelayHigh = 35.00,
        secondaryEvent = EventKind.FootstepSnow, secondaryLevel = 0.034f, secondaryDelayLow = 8.00, secondaryDelayHigh = 20.00,
    ),
    // CricketMeadow
    ScenePreset(
        texture = TextureKind.Forest, bedLevel = 0.075f, brightness = 0.35f, motionRate = 0.03,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Cricket, eventLevel = 0.035f, eventDelayLow = 1.00, eventDelayHigh = 4.00,
        secondaryEvent = EventKind.Owl, secondaryLevel = 0.026f, secondaryDelayLow = 20.00, secondaryDelayHigh = 48.00,
    ),
    // RainyClockRoom
    ScenePreset(
        texture = TextureKind.Rain, bedLevel = 0.085f, brightness = 0.40f, motionRate = 0.07,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.ClockTick, eventLevel = 0.025f, eventDelayLow = 0.75, eventDelayHigh = 1.05,
        secondaryEvent = EventKind.Creak, secondaryLevel = 0.022f, secondaryDelayLow = 20.00, secondaryDelayHigh = 50.00,
    ),
    // MistyBuoy
    ScenePreset(
        texture = TextureKind.Surf, bedLevel = 0.120f, brightness = 0.30f, motionRate = 0.065,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.BuoyBell, eventLevel = 0.035f, eventDelayLow = 16.00, eventDelayHigh = 40.00,
        secondaryEvent = EventKind.WaveSlap, secondaryLevel = 0.032f, secondaryDelayLow = 3.00, secondaryDelayHigh = 8.00,
    ),
    // DeepBambooNight
    ScenePreset(
        texture = TextureKind.Forest, bedLevel = 0.080f, brightness = 0.30f, motionRate = 0.03,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Owl, eventLevel = 0.028f, eventDelayLow = 18.00, eventDelayHigh = 42.00,
        secondaryEvent = EventKind.Creak, secondaryLevel = 0.027f, secondaryDelayLow = 5.00, secondaryDelayHigh = 15.00,
    ),
    // WatermillRuins
    ScenePreset(
        texture = TextureKind.Brook, bedLevel = 0.120f, brightness = 0.40f, motionRate = 0.14,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.Creak, eventLevel = 0.030f, eventDelayLow = 8.00, eventDelayHigh = 22.00,
        secondaryEvent = EventKind.Bubble, secondaryLevel = 0.031f, secondaryDelayLow = 2.00, secondaryDelayHigh = 6.00,
    ),
    // WinterLighthouse
    ScenePreset(
        texture = TextureKind.Ventilation, bedLevel = 0.075f, brightness = 0.20f, motionRate = 0.035,
        droneFrequency = 0.0, droneLevel = 0.000f,
        toneFrequency = 0.0, toneLevel = 0f, tonePulseRate = 0.0,
        event = EventKind.BuoyBell, eventLevel = 0.025f, eventDelayLow = 24.00, eventDelayHigh = 55.00,
        secondaryEvent = EventKind.ClockTick, secondaryLevel = 0.020f, secondaryDelayLow = 0.90, secondaryDelayHigh = 1.10,
    ),
)

internal fun scenePreset(scene: AmbienceScene): ScenePreset = SCENE_PRESETS[scene.ordinal]
